import Repository from './Repository'

export default {
  savePhoneNumber (id, params) {
    return Repository.public().post(
      '/claim/user/' + id + '/phone-number', params
    )
  }
}
